// Use with async & await

export const wait = ms => {
    return new Promise(resolve => {
        setTimeout(() => resolve(ms), ms)
    })
}

export default wait